// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendor":"da5fb4a4939f4127ae64","styles":"0fec21a2fdcbbae0cf2b"}[chunkId] + ".css";
};